import { createFileRoute, Link } from '@tanstack/react-router';
import { DepositEditor } from '../../components/deposits/DepositEditor';
import { useActiveCompanyId } from '../../stores/useCompanyStore';

export const Route = createFileRoute('/_auth/deposits/new')({
  validateSearch: (search: Record<string, unknown>): { copyFrom?: string } => ({
    copyFrom: typeof search.copyFrom === 'string' ? search.copyFrom : undefined,
  }),
  component: RecordDepositPage,
});

function RecordDepositPage() {
  const companyId = useActiveCompanyId();
  const { copyFrom } = Route.useSearch();

  if (!companyId) {
    return (
      <div className="card" style={{ textAlign: 'center', padding: 32 }}>
        <p className="muted">No active company.</p>
        <Link to="/companies" className="btn-primary" style={{ display: 'inline-block', textDecoration: 'none' }}>
          Go to Companies
        </Link>
      </div>
    );
  }

  return <DepositEditor companyId={companyId} copyFromId={copyFrom} />;
}
